export default __webpack_public_path__ + "static/media/thumbnail1.9da502f8.jpg";